module.exports = __webpack_public_path__ + "static/media/watertank.25dbddad.svg";